"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    if (!context.renderNode) {
        return '';
    }
    const parts = element.value.items.map((item) => context.renderNode(item.value)).filter(Boolean);
    return parts.length ? parts.join('\n\n') + '\n' : '';
};
exports.toMarkdown = toMarkdown;
